module.exports = __webpack_public_path__ + "img/pt39_samurai01_shop.350380a0.png";